<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
      <form @submit.prevent="passwordUpdate">
        <md-card>
          <!-- <md-card-header> <div>Change Password</div> </md-card-header> -->
          <md-card-content>
            <p><b>Change Password</b></p>
            <div class="bank-details">
              <md-field>
                <label for="currentPassword">Enter Current Password</label>
                <md-input
                  type="password"
                  v-model="form.oldPassword"
                  placeholder="Enter Current Password"
                  id="currentPassword"
                ></md-input>
              </md-field>
              <md-field>
                <label for="newPassword">Enter New Password</label>
                <md-input
                  type="password"
                  v-model="form.newPassword"
                  placeholder="Enter New Password"
                  id="newPassword"
                ></md-input>
              </md-field>
              <md-field>
                <label for="confirmPassword">Confirm New Password</label>
                <md-input
                  type="password"
                  v-model="confirmPassword"
                  placeholder="Enter New Password again"
                  id="confirmPassword"
                ></md-input>
              </md-field>

              <md-button
                class="md-raised"
                data-background-color="orange"
                type="submit"
                >Update Password</md-button
              >
            </div>
          </md-card-content>
        </md-card>
      </form>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import http from '../../utils/Http.util';

export default {
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
      },
      confirmPassword: '',
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async passwordUpdate() {
      try {
        if (
          !this.form.oldPassword
          || !this.form.newPassword
          || !this.confirmPassword
          || this.confirmPassword !== this.form.newPassword
        ) {
          this.snackBar = {
            show: true,
            message: "Passwords don't match. Please confirm new password",
          };
          return;
        }

        this.$store.commit('busyStatus', true);

        const { message } = await http.authReq(
          '/dashboard/password/update',
          {
            ...this.form,
          },
          'post',
        );

        this.form = {};
        this.confirmPassword = '';
        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
  },
};
</script>

<style scoped>
.md-card-header {
  background: transparent !important;
  font-weight: 500;
}
</style>
